import { NgModule } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SkyTileModule } from './tile';
import { SkyTileContentModule } from './tile-content';
import { SkyTileDashboardModule } from './tile-dashboard';
import { SkyTileDashboardColumnModule } from './tile-dashboard-column';


export class SkyTilesModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    BrowserAnimationsModule
  ],
  exports: [
    SkyTileContentModule,
    SkyTileModule,
    SkyTileDashboardColumnModule,
    SkyTileDashboardModule
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
